import config from "../config";
import * as R from 'ramda';
import { IGalleryStatus } from "../global.d";
import { IComponent, IComponentLink } from "../component.d";
import intl from "react-intl-universal";
import moment from "moment";
import { toJpeg } from "html-to-image";
import { rejects } from "assert";
import filesaver from './filesaver';
import { style } from "./image";

type Procedure = (...args: any[]) => any;
type Options = {
  leading: boolean;
  trailing: boolean;
};

const defaultRemoveType = {
  emptyString: true, //移除空串
  nil: true, // 移除null
  number0: true, //移除数字0
  stringNumber0: false, //移除掉"0"
};
type IObj = {
  [key in string | number]: any;
};

export const sleep = (time: number): PromiseLike<null> => {
  return new Promise<null>((resolve) => {
    window.setTimeout(resolve, time);
  });
};

export const makeJpeg = async (targetHTML: HTMLElement, options: {
  quality: number;
  pixelRatio: number;
}): Promise<string> => {
  const once = () => {
    return new Promise<string>((resolve, reject) => {
      toJpeg(targetHTML, options).then((dataUrl) => {
        resolve(dataUrl);
      }).catch(e => {
        console.error(e);
        reject(e);
      });
    });
  };

  let result = await once();
  await sleep(300);
  result = await once();
  await sleep(300);
  result = await once();

  return result;
}

// 移除掉对象中空的部分，通过配置项可以选择不移除部分空
export const removeEmpty = (obj: IObj, removeTypes = {}) => {
  let filtered = {} as IObj;
  const finalTypes = { ...defaultRemoveType, ...removeTypes };
  for (let x in obj) {
    const value = obj[x];
    const { emptyString, nil, number0, stringNumber0 } = finalTypes;
    if (value === undefined) {
      continue;
    }
    if (emptyString && value === "") {
      continue;
    }
    if (nil && value === null) {
      continue;
    }
    if (number0 && value === 0) {
      continue;
    }
    if (stringNumber0 && value === "0") {
      continue;
    }
    filtered[x] = value;
  }
  return filtered;
};

export function formatImage(url: string, avatar?: string) {
  const theUrl = config.image() + "/" + url;
  if (avatar === "original") {
    avatar = "";
    //return config.downloadImage + theUrl;
  }
  return theUrl + (avatar ? `!${avatar}` : "");
}
//将字节转化成方便阅读的大小显示
export function formatSize(b: number) {
  if (b < 1000) {
    return b + "B";
  }
  if (b < 1000 * 1000) {
    const n = b / 1000;
    return n.toFixed(0) + "K";
  }

  const m = b / 1000 / 1000;
  return m.toFixed(2) + "M";
}

export const saveFile = (url: string, filename: string) => {
  var a = document.createElement("a");
  a.href = url;
  a.download = filename;

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const getFileExt = (str: string) => {
  let split = (str || "").split(".");
  let ext = split.pop() || "";
  ext = ext.toLowerCase();

  if (["xlsx", "xls"].indexOf(ext) > -1) {
    return "excel";
  }
  if (["jpg", "gif", "png", "jpeg"].indexOf(ext) > -1) {
    return "image";
  }
  if (["doc", "docx"].indexOf(ext) > -1) {
    return "word";
  }
  if (["ppt", "pptx"].indexOf(ext) > -1) {
    return "ppt";
  }
  if (["pdf"].indexOf(ext) > -1) {
    return "pdf";
  }

  return "unknown";
};

export const debounce = function (
  func: Procedure,
  wait = 800,
  immediate = true
) {
  var timeout: number,
    args: any[],
    context: any,
    timestamp: number,
    result: any;
  var later = function () {
    // 当wait指定的时间间隔期间多次调用_.debounce返回的函数，则会不断更新timestamp的值，导致last < wait && last >= 0一直为true，从而不断启动新的计时器延时执行func
    var last = new Date().getTime() - timestamp;

    if (last < wait && last >= 0) {
      timeout = window.setTimeout(later, wait - last);
    } else {
      timeout = 0;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null as never as any[];
        }
      }
    }
  };

  return function (this: any) {
    context = this;
    args = arguments as any;
    timestamp = new Date().getTime();
    // 第一次调用该方法时，且immediate为true，则调用func函数
    var callNow = immediate && !timeout;
    // 在wait指定的时间间隔内首次调用该方法，则启动计时器定时调用func函数
    if (!timeout) timeout = window.setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null as never as any[];
    }

    return result;
  };
};

export const throttle = function (
  func: Procedure,
  wait = 800,
  options?: Options
) {
  /* options的默认值
   *  表示首次调用返回值方法时，会马上调用func；否则仅会记录当前时刻，当第二次调用的时间间隔超过wait时，才调用func。
   *  options.leading = true;
   * 表示当调用方法时，未到达wait指定的时间间隔，则启动计时器延迟调用func函数，若后续在既未达到wait指定的时间间隔和func函数又未被调用的情况下调用返回值方法，则被调用请求将被丢弃。
   *  options.trailing = true;
   * 注意：当options.trailing = false时，效果与上面的简单实现效果相同
   */
  var context: any, args: any[], result: any;
  var timeout = 0;
  var previous = 0;
  let opt = options as Options;
  if (!options) {
    opt = { leading: true, trailing: true };
  }
  var later = function () {
    previous = opt.leading === false ? 0 : new Date().getTime();
    timeout = 0;
    result = func.apply(context, args);
    if (!timeout) {
      context = null;
      args = null as never as any[];
    }
  };
  return function (this: any) {
    var now = new Date().getTime();
    if (!previous && opt.leading === false) previous = now;
    // 计算剩余时间
    var remaining = wait - (now - previous);
    context = this;
    args = arguments as any;
    // 当到达wait指定的时间间隔，则调用func函数
    // 精彩之处：按理来说remaining <= 0已经足够证明已经到达wait的时间间隔，但这里还考虑到假如客户端修改了系统时间则马上执行func函数。
    if (remaining <= 0 || remaining > wait) {
      // 由于setTimeout存在最小时间精度问题，因此会存在到达wait的时间间隔，但之前设置的setTimeout操作还没被执行，因此为保险起见，这里先清理setTimeout操作
      if (timeout) {
        clearTimeout(timeout);
        timeout = 0;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) {
        context = null;
        args = null as never as any[];
      }
    } else if (!timeout && opt.trailing !== false) {
      // options.trailing=true时，延时执行func函数
      timeout = window.setTimeout(later, remaining);
    }
    return result;
  };
};

//求arr1和arr2的差集: arr1中有的，但是arr2中没有的部分
export const arrDiff = function <T>(
  arr1: T[],
  arr2: T[],
  cb: (...e: any) => any
) {
  if (!arr1.length) {
    return [];
  }
  let diff = [] as T[];
  arr1.forEach((one) => {
    //如果arr2中找不到就push进去
    let index = arr2.findIndex((element) => {
      let result;
      if (typeof cb === "function") {
        result = cb(one, element);
      } else {
        result = one === element;
      }
      return result;
    });
    if (index === -1) {
      diff.push(one);
    }
  });
  return diff;
};
export const isHtml = (string: string) =>
  /^<(\w+).*?(<\/\1>|\/>)$/g.test(string);
export const isWeb = function () {
  const userAgentInfo = navigator.userAgent;
  const Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
    "MicroMessenger",
  ];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > -1) {
      if (
        Agents[v] === "MicroMessenger" &&
        (userAgentInfo.indexOf("WindowsWechat") > -1 || userAgentInfo.indexOf("MacWechat") > -1)
      ) {
        // flag = true;
      } else {
        flag = false;
        break;
      }
    }
  }
  return flag;
};

// 根据和珊婷的讨论，手机端不需要显示滚动条的地方，PC上都显示自定义滚动条
export const getScrollCls = function () {
  return isWeb() ? "custom-scroll-bar" : "no-scroll-bar";
};

// 判断是否支持webp
export const isSupportWebp = () => {
  try {
    return document.createElement('canvas').toDataURL('image/webp', 0.5).indexOf('data:image/webp') === 0;
  } catch (err) {
    return false;
  }
};

// 是否是微信的web浏览器， 测试发现mac或者pc上都是有这个标识。
export const isWeixinWeb = function () {
  return navigator.userAgent.indexOf("WindowsWechat") > -1 || navigator.userAgent.indexOf("MacWechat") > -1;
};
export const isIos = () => navigator.userAgent.indexOf("iPhone") > -1;
export const isAndroid = () => navigator.userAgent.indexOf("Android") > -1;
export const isIphoneX = function () {
  var userAgent = navigator.userAgent;

  // iphonex
  var ios = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (ios) {
    if (window.screen.height == 812 && window.screen.width == 375) {
      return true;
    } else if (window.screen.height == 896 && window.screen.width == 414) {
      return true;
    }
  }

  return false;
};
// 是否是微信手机浏览器
export const isWeixinMobile = function () {
  return window.isweixin && !window.isweixinweb;
};

// 根据当前相册的状态返回文字和颜色
export const getGalleryStatus = (status: IGalleryStatus) => {
  switch (status) {
    case IGalleryStatus.stop:
    case IGalleryStatus.play:
      return [intl.get("GalleryStatusStart"), "#12BFB4"];
    case IGalleryStatus.config:
    case IGalleryStatus.wait:
      return [intl.get("GalleryStatusWait"), "#ABABAB"];
    case IGalleryStatus.complete:
      return [intl.get("GalleryStatusComplete"), "#ABABAB"];
    case IGalleryStatus.rollback:
      return [intl.get("GalleryStatusRollback"), "#12BFB4"];
    case IGalleryStatus.start:
      return [intl.get("GalleryStatusStart"), "#12BFB4"];
    case IGalleryStatus.end:
      return [intl.get("GalleryStatusEnd"), "#2C90E9"];
    case IGalleryStatus.amazing:
      return [intl.get("GalleryStatusAmazing"), "#12BFB4"];
    case IGalleryStatus.directend:
      return [intl.get("VideoDirectEndStatus"), "#2C90E9"];
    case IGalleryStatus.needpay:
      return [intl.get("GalleryNeedPay"), "#ff5365"];
    case IGalleryStatus.payed:
      return [intl.get("GalleryPayed"), "#12BFB4"];
    default:
      return ["", ""];
  }
};

export const getGalleryURL = (value: string, isold: boolean) => {
  if (isold) {
    return "//wx" + window.__basename + "/gallery?id=" + value;
  } else {
    // @ts-ignore
    return "//" + window.__hostname + "/g/" + value;
  }
};

export const fixedOriginal = (redirect?: boolean) => {
  if (!redirect && window.original_photo) {
    return "/original/1";
  }
  if (!redirect && window.custom_current_watermark && window.match_params && window.match_params.customwatermark) {
    return "/watermark/" + window.match_params.customwatermark;
  }

  return "";
};

export const toOrderPage = (from: string) => {
  return window.location.href = `/g/4fa28eb0?from=${from}&from_id=${window.gallery.orderid}`;
};

export const navigatorTo = (
  opt: IComponentLink,
  justGetUrl: boolean = false,
  redirect?: boolean
) => {
  let { type, value } = opt;
  let target = "";
  if (type == "custom") {
    // @ts-ignore
    target = value;
  }
  if (type == "page") {
    target = "/g/" + value;
  }
  if (type == "subgallery") {
    target = "/g/" + opt.link_id;
  }
  if (type == "gallery") {
    // 这里存在一个老相册和新相册的问题
    if (Number(value) < 1000000) {
      target = "//wx" + window.__basename + "/gallery?id=" + value;
    } else {
      if (opt.link_id) {
        target = "/g/" + opt.link_id;
      } else if (opt.url_labeling) {
        target = "/gti/" + opt.url_labeling;
      }
    }
  }
  if (type == "video") {
    if (opt.link_id) {
      target = `/g/` + opt.link_id;
    } else {
      if (typeof value == "object") {
        // @ts-ignore
        target = `/g/${window.pageDetail.link_id}/video/${value.id}`;
      } else {
        target = `/g/${window.pageDetail.link_id}/video/${value}`;
      }
    }
  }
  if (type == "home") {
    target = `/gti/${window.gallery.url_labeling}`;
  }
  if (type == "order") {
    // window.dispatchEvent(new Event(`BOTTOM_TAB_ORDER`));
    // target = `/page/order/${window.pageDetail.link_id}`;
    target = `/g/4fa28eb0?from=from_order_decorate&from_id=${window.gallery.orderid}`;
  }
  if (type == "empty") {
  }

  if (target && target.match(/\/((gti)|(g))\/[0-9a-z]{6,9}$/gi)) {
    target = target + fixedOriginal(redirect);
  }

  if (!justGetUrl) {
    window.location.href = target;
  }

  return target;
};

// 通用的获取水印
export const getWatermarks = () => {

  //  这个是数据源对应的水印
  const dataDetailWatermarks = R.pathOr('', ['dataDetail', 'watermarks'], window);

  //  这个是相册对应的水印
  const galleryWatermarks = R.pathOr('', ['gallery', 'watermarks'], window);

  //  优先使用精确的数据源水印, 如果没有就使用相册的水印
  let watermarks = dataDetailWatermarks || galleryWatermarks;
  if (watermarks) {
    try {
      watermarks = JSON.parse(watermarks);
    } catch (e) {
      console.error("watermarks parse error", watermarks);
    }
  }
  return watermarks;
};

// 检测是否包含class
export const containClassName = (
  source: string | string[],
  target: string[]
) => {
  if (typeof source == "string") {
    source = source.split(" ").filter(Boolean);

    for (var i = 0; i < source.length; i++) {
      if (target.indexOf(source[i]) > -1) {
        return true;
      }
    }
  }
  return false;
};

// 获取当前链接类型为指定类型的所有数据
export const getPageGalleryLinkType = (
  container: IComponent[],
  result: any[],
  type: string | string[]
) => {
  container.forEach((it: any) => {
    const typeList = type instanceof Array ? type : [type];
    // console.log(typeList, it.type);
    if (it.link && it.link.type && typeList.includes(it.link.type)) {
      result.push(it.link.value);
    }
    if (it.list instanceof Array) {
      result = getPageGalleryLinkType(it.list, result, type);
    } else if (it.children instanceof Array) {
      result = getPageGalleryLinkType(it.children, result, type);
    } else if (it.slides instanceof Array) {
      result = getPageGalleryLinkType(it.slides, result, type);
    } else if (it.images instanceof Array) {
      result = getPageGalleryLinkType(it.images, result, type);
    }
  });

  return result;
};

// 获取当前指定类型的所有数据
export const getPageSameType = (
  container: IComponent[],
  result: IComponent[],
  type: string | string[]
) => {
  container.forEach((it: any) => {
    const typeList = type instanceof Array ? type : [type];
    // console.log(typeList, it.type);
    if (typeList.includes(it.type)) {
      result.push(it);
    }
    if (it.list instanceof Array) {
      result = getPageSameType(it.list, result, type);
    } else if (it.children instanceof Array) {
      result = getPageSameType(it.children, result, type);
    }
  });

  return result;
};

export const updatePageById = (container: IComponent[], cid: string, result: any) => {
  container = container.map((it: IComponent) => {
    if (it && it.cid == cid) {
      return result;
    }
    return it;
  });
};

// 根据指定cid查找组件
export const getComponentById = (container: IComponent[], cid: string) => {
  let result = null as any;
  for (var i = 0; i < container.length; i++) {
    let item = container[i];

    if (item.cid == cid && !result) {
      result = item;
    }
    // @ts-ignore
    else if (item && item.list && !result) {
      // @ts-ignore
      let temp = getComponentById(item.list, cid);
      if (temp) {
        result = temp;
      }
    }
    // @ts-ignore
    else if (item && item.children && !result) {
      // @ts-ignore
      let temp = getComponentById(item.children, cid);
      if (temp) {
        result = temp;
      }
    }
  }

  return result;
};

export const browser = {
  versions: (function () {
    var u = window.navigator.userAgent,
      app = window.navigator.appVersion;
    return {
      trident: u.indexOf("Trident") > -1, //IE内核
      presto: u.indexOf("Presto") > -1, //opera内核
      webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
      gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, //android终端
      iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf("iPad") > -1, //是否iPad
      webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
      weixin: u.indexOf("MicroMessenger") > -1, //是否微信 （2015-01-22新增）
    };
  })(),
};

export const isEmptyObj = (dt: Record<string, unknown>) => {
  for (let x in dt) {
    return false;
  }
  return true;
};

export const formatCommentNumber = (count: number) => {
  count = count || 0;

  if (count >= 100000) {
    return Math.round(count / 10000).toFixed(0) + "w";
  } else if (count >= 10000) {
    return (Math.round(count / 1000) / 10).toFixed(1) + "w";
  } else if (count >= 1000) {
    return (Math.round(count / 100) / 10).toFixed(1) + "k";
  } else {
    return count;
  }
};

export const uuid = (len: number = 8, decimal: number = 32) => {
  var result = "";
  while (len) {
    result += Math.floor(Math.random() * decimal).toString(decimal);
    len--;
  }
  return result;
};

export const getHumanTime = (timeString: string | number) => {
  const date = moment(Number(timeString));
  const now = moment();
  //小于1天用 “XX分钟之前”之类的表示方式
  const diff = now.diff(date, "days");
  //20180826和产品讨论：1天以上，如果跨年，显示年月日时分；如果不跨年 ， 在30天内显示 X天前，超过显示年月日时分
  if (diff <= 1) {
    return date.fromNow();
  } else {
    if (date.year() !== now.year()) {
      return date.format("YYYY-MM-DD HH:mm");
    } else if (diff <= 30) {
      return date.fromNow();
    } else {
      return date.format("YYYY-MM-DD HH:mm");
    }
  }
};

export const fixedLength = (str: string | number, len: number = 2) => {
  str = String(str);
  while (str.length < len) {
    str = `0${str}`;
  }

  return str;
};

export const toTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const getLocalConfig = () => {
  let localSetting = window.localStorage.getItem("config");
  let result = null;
  try {
    if (localSetting) {
      result = JSON.parse(localSetting);
    }
  } catch (e) {

  }

  if (!result) {
    result = {
      language: 'system',
      mode: 'system',
      order: 'system'
    };
  }

  return result;
};

export const setLocalConfig = (obj: any) => {
  if (obj) {
    window.localStorage.setItem("config", JSON.stringify(obj));
  }
};

export const getHomeTabStatus = function () {
  // if (!window.dataDetail) {
  //   return 'home';
  // }
  if (Number(window.pageDetail.parent) == 0) {
    return 'home';
  }
  if (window.dataDetail && (window.dataDetail.id == window.gallery.id)) {
    return 'home';
  }

  return 'parent';
};

export const getHomeTabName = function () {
  // 子相册页面是一定有dataDetail的
  // if (!window.dataDetail) {
  //   return intl.get("Home");
  // }
  if (Number(window.pageDetail.parent) == 0) {
    return intl.get("Home");
  }
  if (window.dataDetail && (window.dataDetail.id == window.gallery.id)) {
    return intl.get("LiveGallery");
  }

  return intl.get("Back Home");
};


export const downloadImagesOneByOne = async (list: Array<{ name: string; url: string }>) => {
  const loadZip = () => {
    return new Promise((resolve) => {
      const jsurl = `${window.location.protocol}//${window.configDetail.use_global ? `iglobal1.jimage.cn` : `image1.jimage.cn`}/npm/jszip/3.10.1/jszip.min.js`;
      if (!window.JSZip) {
        window.appendScript(jsurl);
        let count = 0;
        const timer = setInterval(() => {
          count++;
          if (count >= 10) {
            resolve(undefined);
          }
          if (window.JSZip) {
            clearInterval(timer);
            resolve(undefined);
          }
        }, 1000);
      } else {
        resolve(undefined);
      }
    });
  };
  const saveOne = async (one: { name: string; url: string }, download?: boolean) => {
    try {
      const blob = await fetch(one.url).then((res) => res.blob());
      if (download) {
        filesaver.saveAs(blob, one.name);
        await sleep(0);
      }
      return blob;
    } catch (e) {
      console.error(e);
    }
  };

  await loadZip();

  if (window.JSZip) {
    let zip = new window.JSZip();
    for (let index = 0; index < list.length; index++) {
      const blob = await saveOne(list[index], false);
      zip.file(list[index].name, blob);
    }

    let zipBlob = await zip.generateAsync({
      type: 'blob',
      mimeType: 'application/zip'
    });

    filesaver.saveAs(zipBlob, `${list.length}张照片_${moment().format('HH:mm:ss')}.zip`);
  }

  return true;
  // return new Promise((resolve, reject) => {
  //   list.forEach((item) => {
  //     fetch(item.url)
  //         .then((response) => response.blob())
  //         .then((blob) => {
  //           const url = URL.createObjectURL(blob);
  //           const a = document.createElement('a');
  //           a.href = url;
  //           a.download = item.name;
  //           document.body.appendChild(a);
  //           a.click();
  //           document.body.removeChild(a);
  //           URL.revokeObjectURL(url);
  //           resolve(true);
  //         })
  //         .catch((error) => {
  //           console.error('Error downloading image:', error);
  //           reject(error);
  //         });
  //   });
  // });
};

/**
 * 检查当前相册是否需要付费
 * 需要付费: true
 * 不要付费: false
 */
export const checkCurrentGalleryNeedPay = () => {
  const currentGallery = window.dataDetail ? window.dataDetail : window.gallery;
  //  is_pay_down 为 0 时，不需要付费, 大于0有其他的含义, 所以只需要判断是否大于0
  return Number(currentGallery.is_pay_down) > 0;
}

/**
 * 移除对象中的指定的值, 递归 object 和 Array, 符合的就删除
 * removeValuePatterns({a:1, b:2, c:3}, [2]) => {a:1, c:3}
 * removeValuePatterns({a:1, b:undefined, c:3}, [undefined]) => {a:1, c:3}
 * removeValuePatterns({a:1, b:0, c:3, list:[1,2,3,null,4]}, [null]) => {a:1, b:0, c:3, list:[1,2,3,undefined,4]}
 * @param str
 * @param patterns
 */
export const removeValuePatterns = (str: any, patterns: string[]) => {

}

export const scrollElementToVisibleCompareToAnotherElement = (
  target: HTMLElement,
  container: HTMLElement
) => {
  // 获取 container 的视口高度（实际可见部分）
  const containerHeight = container.clientHeight;

  // 获取 target 和 container 的相对位置
  const targetRect = target.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  // 计算 target 相对于 container 的 top 和 bottom
  const targetTopRelativeToContainer = targetRect.top - containerRect.top;
  const targetBottomRelativeToContainer = targetRect.bottom - containerRect.top;

  // 计算 container 的滚动位置
  const containerScrollTop = container.scrollTop;

  // 判断 target 是否在 container 的视野内
  const targetIsFullyVisible =
    targetTopRelativeToContainer >= 0 &&
    targetBottomRelativeToContainer <= containerHeight;

  if (targetIsFullyVisible) {
    // 如果 target 完全可见，则不需要做任何滚动
    return;
  }

  // 目标理想位置是 container 的中部
  // const targetCenterPositionInContainer = containerHeight / 2;

  // 如果 target 高度比 container 高度大，或者 target 在 container 的下方，我们需要调整 container 的滚动位置
  if (targetBottomRelativeToContainer > containerHeight) {
    // target 在 container 的视野下方，需要滚动
    const scrollAmount =
      targetBottomRelativeToContainer - containerHeight + target.offsetHeight / 2;
    container.scrollTop = containerScrollTop + scrollAmount;
  } else if (targetTopRelativeToContainer < 0) {
    // target 在 container 的视野上方，需要滚动
    const scrollAmount = targetTopRelativeToContainer - target.offsetHeight / 2;
    container.scrollTop = containerScrollTop + scrollAmount;
  }
};
